import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoof: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeRoof"><Path d="M22.895 9.57021L11.9997 1.77014L1.10449 9.57021L2.26872 11.1964L3.99973 9.95717V21H19.9997V9.95717L21.7307 11.1964L22.895 9.57021Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeRoof;
